import firebase from 'firebase/app'
import { ref, onUnmounted } from 'vue'
import "firebase/firestore";

const config = {
    apiKey: "AIzaSyDhlk8MetifAxeFDD8JTKZHcX0oMs8ytjk",
    authDomain: "vue3-crud-4b653.firebaseapp.com",
    projectId: "vue3-crud-4b653",
    storageBucket: "vue3-crud-4b653.appspot.com",
    messagingSenderId: "1096525972894",
    appId: "1:1096525972894:web:2b92865ea9969aafb1828f"
}

const firebaseApp = firebase.initializeApp(config)

const db = firebaseApp.firestore();
const usersCollection = db.collection('users')
const timestamp = firebase.firestore.FieldValue.serverTimestamp();

export {timestamp}

export const createUser = user => {
    return usersCollection.add(user)
}

export const getUser = async id => {
    const user = await usersCollection.doc(id).get()
    return user.exists ? user.data() : null
}

export const updateUser = (id, user) => {
    return usersCollection.doc(id).update(user)
}

export const deleteUser = id => {
    return usersCollection.doc(id).delete()
}

export const useLoadUsers = () => {
    const users = ref([])
    const close = usersCollection.onSnapshot(snapshot => {
        users.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    })
    onUnmounted(close)
    return users
}